/* B.LÊM · Rebrand — comportamento comum: revelar, cabeçalho, gaveta, pesquisa, carrinho, age gate */
(() => {
  if (window.__rx) return; window.__rx = true;
  const doc = document.documentElement, body = document.body;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const isEn = (doc.lang || '').toLowerCase().startsWith('en');
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const T = isEn
    ? { added: 'Added to your cart', err: 'Could not update the cart. Please try again.', from: 'from', none: 'Nothing found for', all: 'See all results' }
    : { added: 'Adicionado ao carrinho', err: 'Não foi possível atualizar o carrinho. Tente novamente.', from: 'desde', none: 'Não encontrámos nada para', all: 'Ver todos os resultados' };
  doc.classList.add('rx-js');
  /* camadas fixas saem do cabeçalho (o transform do cabeçalho prenderia o position:fixed) */
  ['rx-drawer', 'rx-search'].forEach(id => { const el = document.getElementById(id); if (el && el.parentElement !== body) body.appendChild(el); });
  document.querySelectorAll('.rh__veil').forEach(v => body.appendChild(v));

  /* ---------- Revelar ao entrar (uma só vez) + títulos palavra a palavra ---------- */
  const split = el => {
    if (el.dataset.splitDone) return; el.dataset.splitDone = '1';
    const walk = node => {
      [...node.childNodes].forEach(n => {
        if (n.nodeType === 3) {
          const parts = n.textContent.split(/(\s+)/);
          const frag = document.createDocumentFragment();
          parts.forEach(p => {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span'); w.className = 'w';
            const s = document.createElement('span'); s.textContent = p; s.style.setProperty('--i', split.i++);
            w.appendChild(s); frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    };
    split.i = 0; el.setAttribute('aria-label', el.textContent.trim().replace(/\s+/g, ' ')); walk(el);
    el.querySelectorAll('.w').forEach(w => w.setAttribute('aria-hidden', 'true'));
  };
  const io = ('IntersectionObserver' in window && !reduce)
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })
    : null;
  const reveal = (scope = document) => {
    scope.querySelectorAll('.rx [data-split]').forEach(split);
    const els = scope.querySelectorAll('.rx [data-rv]:not(.is-in), .rx [data-split]:not(.is-in), .rx [data-in]:not(.is-in)');
    els.forEach(el => io ? io.observe(el) : el.classList.add('is-in'));
  };
  reveal();
  setTimeout(() => document.querySelectorAll('.rx [data-rv]:not(.is-in), .rx [data-split]:not(.is-in), .rx [data-in]:not(.is-in)').forEach(el => { const r = el.getBoundingClientRect(); if (r.top < innerHeight) el.classList.add('is-in'); }), 1400);
  window.rxReveal = reveal;
  document.addEventListener('shopify:section:load', e => reveal(e.target));

  /* ---------- Faixas arrastáveis (coleção, sugestões) ---------- */
  window.rxRail = rail => {
    if (!rail || rail.dataset.railReady) return; rail.dataset.railReady = '1';
    const scope = rail.closest('[data-rail-scope]') || rail.parentElement;
    const bar = scope.querySelector('[data-rail-bar]');
    const prev = scope.querySelector('[data-rail-prev]'), next = scope.querySelector('[data-rail-next]');
    const upd = () => {
      const max = rail.scrollWidth - rail.clientWidth, vis = rail.clientWidth / rail.scrollWidth;
      const p = max > 0 ? rail.scrollLeft / max : 1;
      if (bar) bar.style.setProperty('--p', Math.max(0.08, Math.min(1, vis + p * (1 - vis))).toFixed(3));
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    };
    const step = () => { const c = rail.firstElementChild; return c ? c.getBoundingClientRect().width + 20 : 320; };
    prev && prev.addEventListener('click', () => rail.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }));
    next && next.addEventListener('click', () => rail.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }));
    rail.addEventListener('scroll', upd, { passive: true }); addEventListener('resize', upd); upd();
    let d = null, moved = false;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button !== 0) return; d = { x: e.clientX, s: rail.scrollLeft, t: e.timeStamp, v: 0, lx: e.clientX }; moved = false; });
    addEventListener('pointermove', e => {
      if (!d) return; const dx = e.clientX - d.x;
      if (!moved && Math.abs(dx) < 6) return;
      if (!moved) { moved = true; rail.classList.add('is-drag'); }
      const dt = Math.max(1, e.timeStamp - d.t); d.v = (e.clientX - d.lx) / dt; d.lx = e.clientX; d.t = e.timeStamp;
      rail.scrollLeft = d.s - dx;
    });
    addEventListener('pointerup', () => {
      if (!d) return; const v = d.v; d = null; if (!moved) return;
      rail.classList.remove('is-drag');
      if (!reduce && Math.abs(v) > 0.2) rail.scrollBy({ left: -v * 320, behavior: 'smooth' });
      setTimeout(() => { moved = false; }, 0);
    });
    rail.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  };
  document.querySelectorAll('[data-rx-rail]').forEach(window.rxRail);

  /* ---------- Cartões que inclinam com o cursor ---------- */
  window.rxTilt = (scope = document) => {
    if (!fine.matches || reduce) return;
    scope.querySelectorAll('[data-tilt]:not([data-tilt-ready])').forEach(c => {
      c.dataset.tiltReady = '1';
      c.addEventListener('pointermove', e => { const r = c.getBoundingClientRect(); const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5; c.style.setProperty('--ry', (x * 7).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 7).toFixed(2) + 'deg'); });
      c.addEventListener('pointerleave', () => { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); });
    });
  };
  window.rxTilt();

  /* ---------- Cabeçalho: estado ao fazer scroll ---------- */
  const hd = document.querySelector('[data-rh]');
  const scroller = () => {
    const pw = document.querySelector('.page-wrapper');
    return (pw && pw.scrollHeight > pw.clientHeight + 2 && getComputedStyle(pw).overflowY !== 'visible') ? pw.scrollTop : (scrollY || doc.scrollTop);
  };
  let lastY = 0, ticking = false;
  const onScroll = () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const y = scroller();
      body.classList.toggle('rx-scrolled', y > 24);
      const locked = body.classList.contains('rx-mega') || body.classList.contains('rx-lock');
      if (!locked) {
        if (y > 420 && y > lastY + 6) body.classList.add('rx-hide');
        else if (y < lastY - 6 || y < 420) body.classList.remove('rx-hide');
      }
      lastY = y;
    });
  };
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  onScroll();

  /* mensagens rotativas da faixa de topo */
  const msgs = [...document.querySelectorAll('[data-rh-msg]')];
  if (msgs.length > 1 && !reduce) {
    let i = 0;
    setInterval(() => {
      const a = msgs[i]; i = (i + 1) % msgs.length; const b = msgs[i];
      a.classList.remove('is-on'); a.classList.add('is-out');
      b.classList.remove('is-out'); b.classList.add('is-on');
      setTimeout(() => a.classList.remove('is-out'), 700);
    }, 4200);
  }

  /* ---------- Painéis do menu ---------- */
  if (hd) {
    const triggers = [...hd.querySelectorAll('[data-mega]')];
    let t;
    const close = () => {
      body.classList.remove('rx-mega');
      hd.querySelectorAll('.rh__mega.is-on').forEach(p => p.classList.remove('is-on'));
      triggers.forEach(b => b.setAttribute('aria-expanded', 'false'));
    };
    const open = key => {
      const p = hd.querySelector('[data-panel="' + key + '"]'); if (!p) return;
      hd.querySelectorAll('.rh__mega.is-on').forEach(x => { if (x !== p) x.classList.remove('is-on'); });
      triggers.forEach(b => b.setAttribute('aria-expanded', b.dataset.mega === key ? 'true' : 'false'));
      p.classList.add('is-on'); body.classList.add('rx-mega'); body.classList.remove('rx-hide');
    };
    triggers.forEach(b => {
      b.addEventListener('click', () => b.getAttribute('aria-expanded') === 'true' ? close() : open(b.dataset.mega));
      b.addEventListener('mouseenter', () => { if (!fine.matches) return; clearTimeout(t); t = setTimeout(() => open(b.dataset.mega), 80); });
    });
    hd.addEventListener('mouseleave', () => { if (!fine.matches) return; clearTimeout(t); t = setTimeout(close, 240); });
    hd.addEventListener('mouseenter', () => clearTimeout(t));
    hd.querySelectorAll('a.rh__a, .rh__logo, .rh__ic').forEach(a => a.addEventListener('mouseenter', () => { if (fine.matches && body.classList.contains('rx-mega')) { clearTimeout(t); t = setTimeout(close, 140); } }));
    const veil = document.querySelector('[data-veil]'); veil && veil.addEventListener('click', close);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && body.classList.contains('rx-mega')) { const b = triggers.find(x => x.getAttribute('aria-expanded') === 'true'); close(); b && b.focus(); } });
    /* a garrafa troca com o sabor sob o cursor */
    hd.querySelectorAll('[data-rh-list] a[data-k]').forEach(a => {
      const pick = () => {
        hd.querySelectorAll('[data-rh-list] a.is-on').forEach(x => x.classList.remove('is-on')); a.classList.add('is-on');
        hd.querySelectorAll('[data-rh-disc] img').forEach(s => s.classList.toggle('is-on', s.dataset.k === a.dataset.k));
      };
      a.addEventListener('mouseenter', pick); a.addEventListener('focus', pick);
    });
  }

  /* ---------- Camadas (gaveta, pesquisa, carrinho): abrir/fechar com foco preso ---------- */
  const layers = [];
  const lock = on => { body.classList.toggle('rx-lock', on); doc.style.overflow = on ? 'hidden' : ''; };
  const openLayer = (el, opener, focusSel) => {
    if (!el || el.classList.contains('is-on')) return;
    layers.push({ el, opener: opener || document.activeElement });
    el.classList.add('is-on'); el.setAttribute('aria-hidden', 'false'); el.removeAttribute('inert'); lock(true);
    setTimeout(() => { const f = el.querySelector(focusSel || '[data-close]'); f && f.focus({ preventScroll: true }); }, reduce ? 0 : 120);
  };
  const closeLayer = el => {
    if (!el || !el.classList.contains('is-on')) return;
    el.classList.remove('is-on'); el.setAttribute('aria-hidden', 'true'); el.setAttribute('inert', '');
    const i = layers.findIndex(l => l.el === el); const l = i > -1 ? layers.splice(i, 1)[0] : null;
    if (!layers.length) lock(false);
    if (l && l.opener && l.opener.focus) l.opener.focus({ preventScroll: true });
  };
  document.addEventListener('keydown', e => {
    const top = layers[layers.length - 1]; if (!top) return;
    if (e.key === 'Escape') { closeLayer(top.el); return; }
    if (e.key === 'Tab') {
      const f = [...top.el.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]),textarea,select,[tabindex]:not([tabindex="-1"])')].filter(x => x.offsetParent !== null || x === document.activeElement);
      if (!f.length) return; const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  document.querySelectorAll('[data-layer]').forEach(el => {
    el.setAttribute('inert', '');
    el.querySelectorAll('[data-close]').forEach(b => b.addEventListener('click', () => closeLayer(el)));
  });

  /* gaveta (telemóvel) */
  const drawer = document.getElementById('rx-drawer');
  document.querySelectorAll('[data-open-drawer]').forEach(b => b.addEventListener('click', () => { openLayer(drawer, b); b.setAttribute('aria-expanded', 'true'); }));
  if (drawer) new MutationObserver(() => { if (!drawer.classList.contains('is-on')) document.querySelectorAll('[data-open-drawer]').forEach(b => b.setAttribute('aria-expanded', 'false')); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  /* ---------- Pesquisa com sugestões ---------- */
  const srch = document.getElementById('rx-search');
  if (srch) {
    const input = srch.querySelector('input[name="q"]'), res = srch.querySelector('[data-res]'), allL = srch.querySelector('[data-all]');
    document.querySelectorAll('[data-open-search]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); if (drawer && drawer.classList.contains('is-on')) closeLayer(drawer); openLayer(srch, b, 'input[name="q"]'); }));
    let ctrl, t;
    const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const fmt = v => { const n = typeof v === 'string' ? parseFloat(v) : v / 100; return n.toFixed(2).replace('.', ',') + ' €'; };
    const run = async q => {
      if (ctrl) ctrl.abort();
      if (q.length < 2) { res.innerHTML = ''; allL.hidden = true; return; }
      ctrl = new AbortController();
      try {
        const r = await fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last', { signal: ctrl.signal });
        const d = await r.json();
        const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!ps.length) { res.innerHTML = '<p class="rs__none">' + T.none + ' «' + esc(q) + '».</p>'; allL.hidden = true; return; }
        res.innerHTML = ps.map((p, i) => '<a class="rs__item" style="--i:' + i + '" href="' + esc(p.url) + '"><figure>' + (p.image ? '<img src="' + esc(p.image) + (p.image.includes('?') ? '&' : '?') + 'width=200" alt="" loading="lazy">' : '') + '</figure><span><b>' + esc(p.title) + '</b><small>' + (p.price_max !== p.price_min && p.price_max ? T.from + ' ' : '') + fmt(p.price_min || p.price) + '</small></span></a>').join('');
        allL.hidden = false; allL.href = root + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      } catch (e) { if (e.name !== 'AbortError') res.innerHTML = ''; }
    };
    input && input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => run(input.value.trim()), 180); });
  }

  /* ---------- Carrinho (gaveta lateral, renderizada pela secção rb-drawer) ---------- */
  const cartEl = document.getElementById('rx-cart');
  const counts = () => document.querySelectorAll('[data-rx-count]');
  const setCount = n => counts().forEach(c => { if (String(c.dataset.n) !== String(n)) { c.textContent = n; c.dataset.n = n; c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); } });
  const swap = html => {
    if (!html || !cartEl) return;
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const fresh = tmp.querySelector('[data-rk-inner]'), cur = cartEl.querySelector('[data-rk-inner]');
    if (fresh && cur) { const sc = cur.querySelector('.rk__body'); const top = sc ? sc.scrollTop : 0; cur.replaceWith(fresh); bindCart(); const ns = cartEl.querySelector('.rk__body'); if (ns) ns.scrollTop = top; }
    const n = fresh && fresh.dataset.count; if (n !== undefined) setCount(n);
  };
  const post = async (url, data) => {
    const r = await fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ sections: 'rb-drawer', sections_url: location.pathname }, data)) });
    const d = await r.json(); if (!r.ok) throw new Error(d.description || d.message || T.err);
    return d;
  };
  const showErr = msg => { const f = cartEl && cartEl.querySelector('[data-rk-err]'); if (f) { f.textContent = msg; f.hidden = false; } };
  const change = async (key, qty, line) => {
    line && line.classList.add('is-busy');
    try { const d = await post('cart/change.js', { id: key, quantity: qty }); swap(d.sections && d.sections['rb-drawer']); }
    catch (e) { line && line.classList.remove('is-busy'); showErr(e.message); }
  };
  let noteT;
  function bindCart() {
    if (!cartEl) return;
    cartEl.querySelectorAll('[data-close]').forEach(b => { if (!b.dataset.b) { b.dataset.b = 1; b.addEventListener('click', () => closeLayer(cartEl)); } });
    cartEl.querySelectorAll('[data-line]').forEach(line => {
      const key = line.dataset.line, q = +line.dataset.qty;
      line.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => change(key, Math.max(0, q + +b.dataset.step), line)));
      const rm = line.querySelector('[data-rm]'); rm && rm.addEventListener('click', () => change(key, 0, line));
    });
    cartEl.querySelectorAll('[data-up]').forEach(b => b.addEventListener('click', async () => {
      b.disabled = true;
      try { const d = await post('cart/add.js', { items: [{ id: +b.dataset.up, quantity: 1 }] }); swap(d.sections && d.sections['rb-drawer']); }
      catch (e) { b.disabled = false; showErr(e.message); }
    }));
    const note = cartEl.querySelector('[data-note]');
    note && note.addEventListener('input', () => { clearTimeout(noteT); noteT = setTimeout(() => fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }), 500); });
  }
  bindCart();
  const openCart = opener => openLayer(cartEl, opener);
  document.querySelectorAll('[data-open-cart]').forEach(b => b.addEventListener('click', e => { if (!cartEl) return; e.preventDefault(); openCart(b); }));
  const refreshCart = async () => {
    try { const r = await fetch(root + '?sections=rb-drawer'); const d = await r.json(); swap(d['rb-drawer']); } catch (e) {}
  };
  /* bottle flies into the cart icon */
  const fly = img => {
    if (reduce || !img) return Promise.resolve();
    const cart = [...document.querySelectorAll('[data-open-cart]')].find(b => b.offsetParent !== null);
    if (!cart) return Promise.resolve();
    const a = img.getBoundingClientRect(), b = cart.getBoundingClientRect();
    if (!a.width) return Promise.resolve();
    const s = Math.min(a.width, a.height, 260);
    const el = document.createElement('div'); el.className = 'rx-fly';
    el.style.cssText = 'left:' + (a.left + a.width / 2 - s / 2) + 'px;top:' + (a.top + a.height / 2 - s / 2) + 'px;width:' + s + 'px;height:' + s + 'px';
    const c = img.cloneNode(); c.removeAttribute('srcset'); c.removeAttribute('sizes'); c.src = img.currentSrc || img.src; c.className = ''; c.style.cssText = '';
    el.appendChild(c); document.body.appendChild(el);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    const anim = el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.35 + 'px,' + (dy * 0.35 - 80) + 'px) scale(.55)', opacity: 1, offset: 0.45 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: 0.6 }
    ], { duration: 820, easing: 'cubic-bezier(.5,0,.2,1)' });
    return anim.finished.then(() => el.remove()).catch(() => el.remove());
  };
  /* API pública para a página de produto e cartões */
  window.rxCart = {
    open: openCart,
    refresh: refreshCart,
    async add(items, opts = {}) {
      const d = await post('cart/add.js', { items });
      const p = fly(opts.img);
      if (opts.open !== false) { await Promise.race([p, new Promise(r => setTimeout(r, 900))]); swap(d.sections && d.sections['rb-drawer']); openCart(opts.opener); }
      else swap(d.sections && d.sections['rb-drawer']);
      return d;
    }
  };
  /* sincroniza se outra aba mudar o carrinho */
  addEventListener('pageshow', e => { if (e.persisted) refreshCart(); });

  /* ---------- Barra de cookies: só depois de confirmar a idade e de algum tempo no site ---------- */
  const COOKIE_DELAY = 7000;
  const cookieReady = () => {
    let t = 0; try { t = +sessionStorage.getItem('bl_gate_t') || 0; } catch (e) {}
    if (!t) { t = Date.now(); try { sessionStorage.setItem('bl_gate_t', String(t)); } catch (e) {} }
    setTimeout(() => doc.classList.add('rx-cookie-ok'), Math.max(0, COOKIE_DELAY - (Date.now() - t)));
  };

  /* ---------- Age gate ---------- */
  const gate = document.getElementById('rx-gate');
  if (!gate || (window.Shopify && Shopify.designMode)) doc.classList.add('rx-cookie-ok');
  if (gate && !(window.Shopify && Shopify.designMode)) {
    /* pergunta-se em cada visita (sessão do browser), como pedido */
    let ok = false; try { ok = sessionStorage.getItem('bl_age_ok') === '1'; } catch (e) {}
    if (ok) cookieReady();
    if (!ok) {
      gate.hidden = false; doc.classList.add('rx-gated');
      requestAnimationFrame(() => requestAnimationFrame(() => gate.setAttribute('data-open', '')));
      const yes = gate.querySelector('[data-gate-yes]'), no = gate.querySelector('[data-gate-no]'), back = gate.querySelector('[data-gate-back]');
      setTimeout(() => yes && yes.focus({ preventScroll: true }), 50);
      yes && yes.addEventListener('click', () => {
        try { sessionStorage.setItem('bl_age_ok', '1'); sessionStorage.setItem('bl_gate_t', String(Date.now())); } catch (e) {}
        cookieReady();
        gate.removeAttribute('data-open'); doc.classList.remove('rx-gated');
        setTimeout(() => { gate.hidden = true; }, reduce ? 0 : 280);
      });
      no && no.addEventListener('click', () => { gate.setAttribute('data-denied', ''); back && back.focus(); });
      back && back.addEventListener('click', () => { gate.removeAttribute('data-denied'); yes && yes.focus(); });
      gate.addEventListener('keydown', e => { if (e.key !== 'Tab') return; const f = [...gate.querySelectorAll('button')].filter(x => x.offsetParent !== null); if (!f.length) return; const a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } });
    }
  }

  /* ---------- Rodapé: newsletter mantém-se visível após envio ---------- */
  if (location.hash === '#rf-nl' || /customer_posted=true/.test(location.search)) { const f = document.getElementById('rf-nl'); f && f.scrollIntoView({ block: 'center' }); }
})();

/* Fotografias: paralaxe suave no scroll (a imagem desliza um pouco dentro da moldura) */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches || matchMedia('(max-width: 899px)').matches) return;
  const sel = '.rpg-heroimg img, .rb-man__img img, .rp-og__art .rx-photo img, .rpg-store figure img, .rpg-occ__c figure img, .rb-ab__photo img, .rs-ed__img img';
  let els = [], tick = false;
  const collect = () => { els = [...document.querySelectorAll(sel)]; els.forEach(e => e.classList.add('rx-par')); };
  const upd = () => {
    tick = false;
    const vh = innerHeight;
    for (const img of els) {
      const r = img.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      const p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2); // -1..1
      img.style.setProperty('--py', (p * -26).toFixed(1) + 'px');
    }
  };
  const on = () => { if (!tick) { tick = true; requestAnimationFrame(upd); } };
  collect(); upd();
  document.addEventListener('scroll', on, { capture: true, passive: true });
  addEventListener('resize', on);
  document.addEventListener('shopify:section:load', () => { collect(); upd(); });
})();
